import { createModelSegment } from 'client/data/luckdragon/segment';
import { EdmundsAPI } from 'client/data/api/api-client';
import { withMetrics } from 'client/data/api/api-metrics';
import { VisitorModel } from 'client/data/models/visitor';
import { buildLeadTargetsApiUrl } from 'client/site-modules/shared/utils/lead-form/build-lead-targets-api-url';
import { flavorStore } from 'client/utils/flavor';
import { FLAVOR_GROUP_NAMES } from 'client/site-modules/shared/constants/flavors';

const EMPTY = 'EMPTY';

function handleEmpty(value, defaultValue) {
  return value === EMPTY ? defaultValue : value;
}

function handleBooleanString(value, defaultValue) {
  if (value === 'true') {
    return true;
  } else if (value === 'false') {
    return false;
  }

  return defaultValue;
}

/**
 * EMPTY is used here because the paths doesn't support empty strings as "keys" for an object
 * @param make
 * @param model
 * @param year
 * @param styleId
 * @param omitStyleId
 * @param omitYear
 * @param strategy
 * @param radius
 * @param vin
 * @param leadTargetsSize
 * @param isPickup
 * @param apiSubModel
 * @param encodedTrim
 * @returns {string}
 */
export function buildLeadTargetsPath({
  make = EMPTY,
  model = EMPTY,
  year = EMPTY,
  styleId = EMPTY,
  omitStyleId = false,
  omitYear = false,
  strategy = EMPTY,
  radius = EMPTY,
  vin = EMPTY,
  leadTargetsSize = EMPTY,
  isPickup = false,
  apiSubModel = EMPTY,
  encodedTrim = EMPTY,
}) {
  return `make["${make}"].model["${model}"].year["${year}"].styleId["${styleId}"].omitStyleId["${omitStyleId}"].omitYear["${omitYear}"].strategy["${strategy}"].radius["${radius}"].vin["${vin}"].leadTargetsSize["${leadTargetsSize}"].isPickup["${isPickup}"].apiSubModel["${apiSubModel}"].encodedTrim["${encodedTrim}"].leadTargets`;
}

export const LeadTargetsModel = createModelSegment('leadTargets', [
  {
    path: 'make["{make}"].model["{model}"].year["{year}"].styleId["{styleId}"].omitStyleId["{omitStyleId}"].omitYear["{omitYear}"].strategy["{strategy}"].radius["{radius}"].vin["{vin}"].leadTargetsSize["{leadTargetsSize}"].isPickup["{isPickup}"].apiSubModel["{apiSubModel}"].encodedTrim["{encodedTrim}"].leadTargets',
    async resolve(
      {
        make,
        model,
        year,
        styleId,
        omitStyleId,
        omitYear,
        strategy,
        radius,
        vin,
        leadTargetsSize,
        isPickup,
        apiSubModel,
        encodedTrim,
      },
      context
    ) {
      const { zipCode, latitude, longitude, dma, stateCode } = await context.resolveValue('location', VisitorModel);

      const url = buildLeadTargetsApiUrl({
        make: handleEmpty(make, ''),
        model: handleEmpty(model, ''),
        year: handleEmpty(year, ''),
        styleId: handleEmpty(styleId, ''),
        omitStyleId: handleBooleanString(omitStyleId, false),
        omitYear: handleBooleanString(omitYear, false),
        strategy: handleEmpty(strategy, ''),
        zipCode,
        latitude,
        longitude,
        dma,
        radius: handleEmpty(radius, ''),
        stateCode,
        vin: handleEmpty(vin, ''),
        leadTargetsSize: handleEmpty(leadTargetsSize, ''),
        isPickup: handleBooleanString(isPickup, false),
        apiSubModel: handleEmpty(apiSubModel, ''),
        encodedTrim: handleEmpty(encodedTrim, ''),
        targetGroups: flavorStore.findByGroup(FLAVOR_GROUP_NAMES.TARGET_GROUP),
      });

      return withMetrics(EdmundsAPI, context)
        .fetchJson(url)
        .then(result => (result && result.results) || []);
    },
  },
]);
